import { TFunction } from 'i18next'
import type { TextBubbleCopy } from 'ComponentLibrary/src/widgets/Annotations'

export const getTextBubbleCopy = (tTextBubble: TFunction): TextBubbleCopy => ({
    actions: {
        edit: tTextBubble('actions.edit'),
        deleteAnnotation: tTextBubble('actions.deleteAnnotation'),
        deleteThread: tTextBubble('actions.deleteThread'),
        delete: tTextBubble('actions.delete'),
        cancel: tTextBubble('actions.cancel'),
        reply: tTextBubble('actions.reply'),
        close: tTextBubble('actions.close'),
    },
    unknownUser: tTextBubble('unknownUser'),
    createdInDraft: (draftVersion) => tTextBubble('createdInDraft', { draftVersion }),
    editAnnotationPlaceholder: tTextBubble('editAnnotationPlaceholder'),
    editReplyPlaceholder: tTextBubble('editReplyPlaceholder'),
    createAnnotationPlaceholder: tTextBubble('createAnnotationPlaceholder'),
    createReplyPlaceholder: tTextBubble('createReplyPlaceholder'),
    deletedAnnotation: tTextBubble('deletedAnnotation'),
    edited: tTextBubble('edited'),
    deleteModalTitle: tTextBubble('deleteModalTitle'),
    deleteConfirmation: (includeReplies) => tTextBubble(includeReplies ? 'deleteConfirmationWithReplies' : 'deleteConfirmation'),
    notificationTooltip: tTextBubble('notificationTooltip'),
    immediatelyVisible: tTextBubble('immediatelyVisible'),
})
